import React, { useState } from 'react';

import {
  Text, Image, HStack, Center, StackProps,
} from '@chakra-ui/react';

import CarouselModal from 'containers/Modals/Carrousel';

interface ImageListProps extends StackProps {
    value: string[];
}

export function Images({ value, ...rest }:ImageListProps) {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const arr = value.length > 2 ? value?.slice(0, 1) : value;
  return (
    <HStack
      spacing="2px"
      {...rest}>
      {arr.map((url) => (
        <Image
          objectFit="cover"
          onClick={() => setOpenModal(true)}
          borderRadius={2}
          src={url}
          width="40px"
          height="40px"
        />
      ))}
      <Center
        onClick={() => setOpenModal(true)}
        hidden={value.length <= 3}
        bg="gray.400"
        borderRadius={2}
        width="40px"
        height="40px">
        <Text
          color="white.default"
          variant="2xSmallSemiBold">+{value.length - 1}
        </Text>
      </Center>
      <CarouselModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
        images={value}
      />
    </HStack>
  );
}
